import { ChargeTypeRepoImpl } from "domain/repository/ChargeType/ChargeTypeRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { CounterCustomerChargeRepoImpl } from "domain/repository/CounterCustomerCharge/CounterCustomerChargeRepoImpl";
import { OpsLineRepoImpl } from "domain/repository/OpsLine/OpsLineRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { RequestServiceCodeRepoImpl } from "domain/repository/RequestServiceCode/RequestServiceCodeRepoImpl";
import { TransferOfChargeRepoImpl } from "domain/repository/TransferOfCharge/TransferOfChargeRepoImpl";
import { useTransferOfChargeTracked } from "presentation/store/TransferOfCharge/TransferOfChargeProvider";
import { TransferOfChargeVM } from "presentation/viewModel/TransferOfCharge/TransferOfChargeVM";
import { useMemo } from "react";

export const useTransferOfChargeVM = () => {
    const [, setTransferOfChargeState] = useTransferOfChargeTracked();
    const transferOfChargeVM = useMemo(() =>
        TransferOfChargeVM({
            dispatch: [setTransferOfChargeState],
            transferOfChargeRepo: TransferOfChargeRepoImpl(),
            opsLineRepo: OpsLineRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            chargeTypeRepo: ChargeTypeRepoImpl(),
            requestServiceCodeRepo: RequestServiceCodeRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
            counterCustomerChargeRepo: CounterCustomerChargeRepoImpl()
        }), [setTransferOfChargeState])

    return transferOfChargeVM
}